import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import GarinTzabarStatic from './GarinTzabarStatic';

const GarinTzabar = () => (
  <ServicePageShell strapiApiId="service-garin-tzabar" defaultTitle="Garin Tzabar" StaticFallback={GarinTzabarStatic} />
);

export default GarinTzabar;
